import React from 'react';
import { Route, BrowserRouter } from 'react-router-dom';
import App from './App';
import history from './history';
import { AuthProvider } from './AuthProvider';

export const makeMainRoutes = () => {
  return (
      <BrowserRouter history={history} component={App}>
        <div>          
          <Route path="/" render={(props) => {
              return <AuthProvider clientId={'TNdfEGVFmNwwb6LJgM5M2n3sdNWU74wX'} domain={'arupdigital.au.auth0.com'} >
                <App />
              </AuthProvider>
              
          }}/>          
         
        </div>
      </BrowserRouter>
  );
}



// WEBPACK FOOTER //
// ./src/routes.js